import { render, staticRenderFns } from "./AwesomeSlider.vue?vue&type=template&id=00f6e456&scoped=true&"
import script from "./AwesomeSlider.vue?vue&type=script&lang=js&"
export * from "./AwesomeSlider.vue?vue&type=script&lang=js&"
import style0 from "./AwesomeSlider.vue?vue&type=style&index=0&id=00f6e456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6e456",
  null
  
)

export default component.exports